import { useJsApiLoader } from "@react-google-maps/api";
import * as Env from "src/services/env";

export const placesApi: Array<"places"> = ["places"];
export function useLoadGooglePlacesScript() {
  const env = Env.read();
  return useJsApiLoader({
    googleMapsApiKey: env.VITE_GOOGLE_API_KEY || "",
    libraries: placesApi,
  });
}
